import moment from 'moment';
import {
  GermanCalculationType,
  GermanCalculatorInstallmentPeriod,
  GermanCalculatorPerpetualAnnuity,
  GermanCalculatorResultType,
  GermanCalculatorState,
  GermanPensionAdjustments,
  GermanPensionCalculatorAnnualPensionAdjustment,
  GermanPensionCalculatorConsiderInflation,
  GermanPensionCalculatorEmployedInEast,
  GermanPensionCalculatorGender,
  GermanPensionCalculatorKnowPayPoints,
} from '../types/german-calculator.type';

export const RETIREMENT_AGE_YEARS = ['63', '64', '65', '66', '67'];
export const RETIREMENT_AGE_MONTHS = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
];

export const MIN_AGE_DIFFERENCE_FROM_CURRENT = 100;
export const MAX_AGE_DIFFERENCE_FROM_CURRENT = 0;
export const CALCULATOR_DATE_FORMAT = 'YYYY-MM-DD';
export const VALIDATION_PATTERN_NUMBER_INTEGER = /^([0-9])*(\d)+?$/;
export const VALIDATION_PATTERN_NUMBER_DECIMAL = /^([0-9])*(\.){0,1}(\d)+?$/;
export const VALIDATION_PATTERN_NUMBER_INTEGER_GERMANY = /^([0-9])*(\,(\d)+)?$/;
export const VALIDATION_PATTERN_NUMBER_DECIMAL_GERMANY = /^([0-9\.])*(\,(\d)+)?$/;
export const VALIDATION_PATTERN_DATE = /^(\d){4}-(\d){2}-(\d){2}$/;
export const VALIDATION_PATTERN_DATE_YEAR = /^(\d){4}$/;

export const GERMAN_CALCULATOR_ONE_TIME_INVESTMENT_INITIAL_STATE: GermanCalculatorState = {
  config: {
    defaultResultType: GermanCalculatorResultType.CHART,
    formValues: {
      calculationTypeItems: [],
      bindValues: {
        defaultCalculationType: GermanCalculationType.END_VALUE,
        initialContribution: '10000',
        finalCapital: '14025',
        initialSalesCharge: '0',
        investmentPeriod: '5',
        interestRate: '5',
      },
      maxValues: {
        maxInitialContribution: '100000',
        maxFinalCapital: '100000',
        maxSalesCharge: '20',
        maxInvestmentPeriod: '100',
        maxInterestRate: '100',
      },
      maxLabelValues: null,
      invalidLabelValues: null,
    },
  },
};

export const GERMAN_CALCULATOR_SAVINGS_PLAN_INITIAL_STATE: GermanCalculatorState = {
  config: {
    defaultResultType: GermanCalculatorResultType.CHART,
    formValues: {
      calculationTypeItems: [],
      bindValues: {
        defaultCalculationType: GermanCalculationType.END_VALUE,
        initialContribution: '1000',
        finalCapital: '14025',
        savingsRate: '50',
        initialSalesCharge: '0',
        investmentPeriod: '5',
        interestRate: '5',
        defaultInstallmentPeriod: GermanCalculatorInstallmentPeriod.MONTHLY,
      },
      maxValues: {
        maxInitialContribution: '100000',
        maxFinalCapital: '100000',
        maxSavingsRate: '1000',
        maxSalesCharge: '20',
        maxInvestmentPeriod: '100',
        maxInterestRate: '100',
      },
      maxLabelValues: null,
      invalidLabelValues: null,
    },
  },
};

export const GERMAN_CALCULATOR_WITHDRAWL_PLAN_INITIAL_STATE: GermanCalculatorState = {
  config: {
    defaultResultType: GermanCalculatorResultType.CHART,
    formValues: {
      calculationTypeItems: [],
      bindValues: {
        defaultCalculationType: GermanCalculationType.INITIAL_CAPITAL,
        initialContribution: '38399',
        pension: '250',
        investmentPeriod: '20',
        finalCapital: '0',
        initialSalesCharge: '0',
        interestRate: '5',
        defaultPerpetualAnnuity: GermanCalculatorPerpetualAnnuity.NO,
        defaultPayout: GermanCalculatorInstallmentPeriod.MONTHLY,
      },
      maxValues: {
        maxInitialContribution: '100000',
        maxPension: '10000',
        maxInvestmentPeriod: '100',
        maxFinalCapital: '100000',
        maxSalesCharge: '20',
        maxInterestRate: '100',
      },
      maxLabelValues: null,
      invalidLabelValues: null,
    },
  },
};

export const GERMAN_CALCULATOR_PENSION_INITIAL_STATE: GermanCalculatorState = {
  pensionConfig: {
    steps: [],
    currentStep: 0,
    formValues: {
      bindValues: {
        gender: GermanPensionCalculatorGender.MALE,
        knowPayPoints: GermanPensionCalculatorKnowPayPoints.YES,
        employedInEast: GermanPensionCalculatorEmployedInEast.OLD,
        pointsSectionEmployedInEast: GermanPensionCalculatorEmployedInEast.OLD,
        retirementAgeMonths: RETIREMENT_AGE_MONTHS[0],
        retirementAgeYears: RETIREMENT_AGE_YEARS[0],
        pensionAdjustments: GermanPensionAdjustments.NONE,
        considerInflation: GermanPensionCalculatorConsiderInflation.NO,
        annualPensionAdjustment:
          GermanPensionCalculatorAnnualPensionAdjustment.NO,
      },
      maxValues: {
        birthDate: null,
        lastAccountClearing: null,
      },
      minValues: {
        birthDate: null,
        lastAccountClearing: null,
      },
    },
  },
};
